import {
    GAS_LIMIT,
    MERGE_BLOCK,
    BUILDER_VANILLA,
    formatRelayMap,
    formatBuilder,
    formatValidator,
    getFormattedDate,
    generateEmptyInfo
} from '../utils/constants.js';

function blockInfoTable(block_info) {
    if (block_info.block >= MERGE_BLOCK) {
        var block = block_info.block
        var slot = block_info.slot
        var hash = block_info.block_hash
        var time = getFormattedDate(block_info.timestamp)
        var builder = formatBuilder(block_info)
        var validator = formatValidator(block_info)
        var relays = formatRelayMap(block_info.winner.relays)
        var base_fee = (block_info.base_fee * 1e9).toFixed(2) + " Gwei"
        var prio_fee = (block_info.prio_fee * 1e9).toFixed(2) + " Gwei"
        var txs = block_info.transactions?.length ?? 0
        var gas_used = block_info.gas_used + " - " + (block_info.gas_used / GAS_LIMIT * 100).toFixed(2) + "%"
        var payout = block_info.payout.toFixed(8)
        if (payout === 0) {
            payout = "-"
        } else {
            payout += " ETH"
        }
        if (block_info.alimony > 0) {
            payout += ` <span style="color:#FFFF00;">(${block_info.alimony.toFixed(8)})</span>`
        }
        var payback = block_info.payback.toFixed(8)
        if (payback === 0) {
            payback = "-"
        } else {
            payback += " ETH"
        }
        var payment = block_info.payment.toFixed(8) + " ETH"
        var difference = block_info.difference.toFixed(8)
        if (difference === 0) {
            difference = "-"
        } else {
            difference += " ETH"
        }
        if (block_info.builder === BUILDER_VANILLA) {
            difference = "MEV"
            difference = `<span style="color: #e59c23">${difference}</span>`
        }
        if (block_info.offset < 0) {
            difference += ` (${block_info.offset / 1000}s)`
            difference = `<span style="color: #e59c23">${difference}</span>`
        }
    } else {
        var block = ""
        var slot = ""
        var hash = ""
        var time = ""
        var builder = ""
        var validator = ""
        var relays = ""
        var base_fee = "&nbsp;"
        var prio_fee = "&nbsp;"
        var txs = "&nbsp;"
        var gas_used = "&nbsp;"
        var payout = "&nbsp;"
        var payback = "&nbsp;"
        var payment = "&nbsp;"
        var difference = "&nbsp;"
    }

    let tableHTML = `
    <table class="block-info-table">
        <colgroup>
            <col style="width: 12.5%">
            <col style="width: 87.5%">
        </colgroup>
        <tr>
            <th>Number</th>
            <td>${block}</td>
        </tr>
        <tr>
            <th>Slot</th>
            <td>${slot}</td>
        </tr>
        <tr>
            <th>Hash</th>
            <td>${hash}</td>
        </tr>
        <tr>
            <th>Time</th>
            <td>${time}</td>
        </tr>
        <tr>
            <th>Builder</th>
            <td>${builder}</td>
        </tr>
        <tr>
            <th>Validator</th>
            <td>${validator}</td>
        </tr>
        <tr>
            <th>Relays</th>
            <td class="table-line-break">${relays}</td>
        </tr>
    
    <table class="block-info-table equal-width-table">
        <colgroup>
            <col style="width: 25%">
            <col style="width: 25%">
            <col style="width: 25%">
            <col style="width: 25%">
        </colgroup>
        <tr>
            <th>Validator Payment</th>
            <th>Difference / Offset</th>
            <th>Builder Payout</th>
            <th>Coinbase Payback</th>
        </tr>
        <tr>
            <td>${payment}</td>
            <td>${difference}</td>
            <td>${payout}</td>
            <td>${payback}</td>
        </tr>
    </table>
    `

    /*
    <table class="block-info-table equal-width-table">
        <colgroup>
            <col style="width: 25%">
            <col style="width: 25%">
            <col style="width: 25%">
            <col style="width: 25%">
        </colgroup>
        <tr>
            <th>Base Fee</th>
            <th>Priority Fee</th>
            <th>Transactions</th>
            <th>Gas</th>
        </tr>
        <tr>
            <td>${base_fee}</td>
            <td>${prio_fee}</td>
            <td>${txs}</td>
            <td>${gas_used}</td>
        </tr>
    </table>
    */
    return tableHTML;
}


export default class BlockInfoUI {

    constructor(block_info_id) {
        this.padding = { top: 20, right: 20, bottom: 20, left: 20 };
        this.block_info_block_div = document.querySelector(block_info_id); // Replace with the ID of your parent div
        this.setBlockInfo(generateEmptyInfo())
    }

    setBlockInfo = (block_info) => {
        this.block_info = block_info
        this.setBlockInfoNumber(block_info.block)
        this.block_info_block_div.innerHTML = blockInfoTable(block_info)
        this.setupCopyClipboard()
    }

    setBlockInfoNumber = (block_number) => {
        const block_info_number = document.querySelector('#block_info_number');
        if (block_info_number && block_number >= MERGE_BLOCK) {
            block_info_number.textContent = "- " + block_number;
        }
    }

    setupCopyClipboard = () => {
        const copyOverlay = document.getElementById("copy-overlay");

        this.showCopyOverlay = (message) => {
            copyOverlay.textContent = message;
            copyOverlay.classList.add("show-overlay");
            setTimeout(() => {
                copyOverlay.classList.remove("show-overlay");
            }, 2000);
        }

        const builderKeySymbol = document.getElementById("builder_pubkey");
        builderKeySymbol?.addEventListener("click", () => {
            navigator.clipboard.writeText(this.block_info.winner.builder_pubkey)
                .then(() => {
                    this.showCopyOverlay("Copied to clipboard!");
                })
                .catch((error) => {
                    console.error("Failed to copy string:", error);
                    this.showCopyOverlay("Copy failed!");
                });
        });

        const proposerKeySymbol = document.getElementById("proposer_pubkey");
        proposerKeySymbol?.addEventListener("click", () => {
            navigator.clipboard.writeText(this.block_info.winner.proposer_pubkey)
                .then(() => {
                    this.showCopyOverlay("Copied to clipboard!");
                })
                .catch((error) => {
                    console.error("Failed to copy string:", error);
                    this.showCopyOverlay("Copy failed!");
                });
        });
    }
}